import { ParseResult, Schema } from "@effect/schema";
import { PERCENT_DECIMALS, Percent, PercentFromSelf } from "@silo/types";
import { parseBigIntWithDecimals, shiftDecimal } from "@silo/utils";
import { pipe } from "effect";
import { formatUnits } from "viem";

export const GraphPercent = Schema.transformOrFail(
  Schema.String,
  PercentFromSelf,
  {
    decode: (s, _, ast) => {
      try {
        const { value } = parseBigIntWithDecimals(PERCENT_DECIMALS)(s);

        return pipe(shiftDecimal(value, -2), Percent.make, ParseResult.succeed);
      } catch (error) {
        if (error instanceof Error) {
          return ParseResult.fail(new ParseResult.Type(ast, s, error.message));
        }

        return ParseResult.fail(
          new ParseResult.Type(ast, s, `Failed to convert ${s} to Percent`)
        );
      }
    },
    encode: (input) => {
      return pipe(
        formatUnits(shiftDecimal(input, 2), PERCENT_DECIMALS),
        ParseResult.succeed
      );
    },
  }
);
